var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_6_1",
    "data-name": "Component 6 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_900",
    "data-name": "Ellipse 900",
    fill: "#fff",
    stroke: "#ff4f01",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 74,
    r: 74,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 74,
    r: 72.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "research",
    d: "M20.112,54.516l-4.389-4.388a1.144,1.144,0,0,1-.142-1.457l1.9-2.836-2.412-5.822-3.349-.66a1.144,1.144,0,0,1-.93-1.131V32.016a1.144,1.144,0,0,1,.93-1.131l3.349-.66L17.482,24.4l-1.9-2.836a1.143,1.143,0,0,1,.142-1.457l4.389-4.389a1.144,1.144,0,0,1,1.457-.142l2.836,1.9,5.822-2.412.66-3.349a1.143,1.143,0,0,1,1.131-.929h6.206a1.144,1.144,0,0,1,1.131.929l.66,3.349,5.822,2.412,2.836-1.9a1.143,1.143,0,0,1,1.457.142l4.389,4.389a1.144,1.144,0,0,1,.142,1.457l-1.9,2.836,2.412,5.822,3.349.66a1.143,1.143,0,0,1,.93,1.131v6.206a1.144,1.144,0,0,1-.93,1.131l-3.349.66L52.681,46.02,51,44.339a3.165,3.165,0,0,0-2.5-.916.683.683,0,0,1,.1-.3A15.658,15.658,0,1,0,43.126,48.6a.684.684,0,0,1,.3-.1A3.164,3.164,0,0,0,44.34,51l1.68,1.68-6.006,2.488-.66,3.349a1.143,1.143,0,0,1-1.131.929H32.017a1.143,1.143,0,0,1-1.131-.929l-.66-3.349L24.4,52.756l-2.836,1.9a1.144,1.144,0,0,1-1.457-.142ZM5.729,35.119a29.4,29.4,0,0,1,43.24-25.93l-1.82.3a.864.864,0,1,0,.283,1.705L51.6,10.5A.865.865,0,0,0,52.25,9.3L50.516,5.435a.864.864,0,0,0-1.577.708l.633,1.408A31.123,31.123,0,0,0,11.752,55.671a.864.864,0,1,0,1.3-1.142,29.358,29.358,0,0,1-7.32-19.409Zm58.782,0a29.23,29.23,0,0,1-5.555,17.175l1.251,1.251a31.135,31.135,0,0,0-1.718-38.978.864.864,0,1,0-1.3,1.142,29.358,29.358,0,0,1,7.32,19.409ZM35.12,64.51A29.382,29.382,0,0,1,21.27,61.049l1.82-.3a.864.864,0,1,0-.283-1.705l-4.17.692a.865.865,0,0,0-.648,1.207L19.724,64.8A.864.864,0,0,0,21.3,64.1l-.633-1.408a31.16,31.16,0,0,0,32.877-2.481l-1.251-1.251A29.227,29.227,0,0,1,35.12,64.51Zm24.441-9.166a2.981,2.981,0,1,1-4.216,4.216l-9.782-9.782a1.441,1.441,0,0,1-.069-1.959l-.342-.342a2.363,2.363,0,0,0-2.91-.364,13.929,13.929,0,1,1,4.872-4.872,2.363,2.363,0,0,0,.364,2.909l.342.342a1.441,1.441,0,0,1,1.959.069l9.782,9.782ZM45.754,35.119A10.634,10.634,0,1,0,35.12,45.753,10.655,10.655,0,0,0,45.754,35.119Zm-6.9-4.558L32.722,36.7l-1.7-2.953a1.577,1.577,0,1,0-2.732,1.577l2.648,4.586a1.707,1.707,0,0,0,2.686.354l7.468-7.468a1.577,1.577,0,1,0-2.231-2.231Z",
    transform: "translate(39 39.001)",
    fill: "#ff4f01",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantage2);
export default __webpack_public_path__ + "static/media/advantage2.2a440911f6ba9e95d751b17fd2384118.svg";
export { ForwardRef as ReactComponent };